<template>
  <div class="partner">
    <tgo-partner :partners="partners['2024年度顶级共创伙伴']" title="2024年度顶级共创伙伴" :itemIsCenter="true">
      <com-title title="合作伙伴" slot="mainTitle"></com-title>
    </tgo-partner>
    <!-- <tgo-partner :partners="partners['2020年度高级共创合作伙伴']" title="2020年度高级共创合作伙伴"></tgo-partner> -->
    <logo-partner class="partners-2020" :partners="partners['2024年度共创合作伙伴']" subtitle="2024年度共创合作伙伴"></logo-partner>
    <logo-partner class="partners-2020" :partners="partners['2022年度战略共创伙伴']" subtitle="2022年度战略共创伙伴"></logo-partner>
    <logo-partner class="partners-2020" :partners="partners['2020年度共创合作伙伴']" subtitle="2020年度共创合作伙伴"></logo-partner>
    <logo-partner :partners="partners['2019-2020年度共创伙伴']" subtitle="2019-2020年度共创伙伴"></logo-partner>
  </div>
</template>

<script>
import comTitle from '@/base/ego-title'
import tgoPartner from './com-partner2.vue'
import logoPartner from '@/components/com-partner'

export default {
  components: {
    comTitle,
    tgoPartner,
    logoPartner
  },
  computed: {
    partners () {
      return {
        '2024年度顶级共创伙伴': [{
          link: 'https://www.ingzhong.com',
          // avatar: 'https://static001-test.geekbang.org/resource/image/3c/89/3c1fc1788131d20011cf06bf6f131b89.jpg',
          avatar: 'https://static001.geekbang.org/resource/image/75/69/756892e21d4a34d58fa02bea68a00269.png',
          word: '赢众海外咨询是一家专业从事涉美移民身份规划、外国人来华签证办理，跨境税务及法律服务的专业机构。核心团队由律师、注册会计师、高级咨询师组成且平均从业时间超过11年。国内多地咨询中心及文案中心服务中国金融服务机构，移民公司，家族办公室等200余家并每年为数亿美元跨境投资及高级人才流动保驾护航。'
        }],
        '2024年度共创合作伙伴': [{
          link: 'https://cloud.tencent.com/',
          // avatar: 'https://static001-test.geekbang.org/resource/image/3c/89/3c1fc1788131d20011cf06bf6f131b89.jpg',
          avatar: 'https://static001.geekbang.org/resource/image/3d/c2/3dffb37162726157da3dddda139323c2.jpg',
          word: ''
        }],
        '2022年度战略共创伙伴': [{
          link: 'https://www.renruihr.com',
          // avatar: 'https://static001-test.geekbang.org/resource/image/3c/89/3c1fc1788131d20011cf06bf6f131b89.jpg',
          avatar: 'https://static001.geekbang.org/resource/image/14/ae/14b05a3ef071c311aa797ec5b45750ae.png',
          word: '人瑞人才是中国领先的综合人力资源解决方案提供商，致力于打造数字化时代的人才生态供应链，并构建人才管理数字化与企业战略、业务数字化的连接和应用。人瑞人才坚持以效果为导向的服务模式，通过强执行力的组织体系与专业团队，为客户提供满意的、适应数字化需求的人力资源一体化服务！'
        }],
        '2020年度共创合作伙伴': [{
          link: 'https://docs.agora.io/cn',
          // avatar: 'https://static001-test.geekbang.org/resource/image/3c/89/3c1fc1788131d20011cf06bf6f131b89.jpg',
          avatar: require('./assets/shengwang.jpg'),
          word: '声网Agora是实时音视频云行业开创者，是全球领先的专业服务商。使用声网SDK产生的实时音视频通话分钟数超8亿/日。声网服务覆盖社交直播、在线教育、游戏、IoT、医疗、企业协作等10余行业，100多种场景。使用声网服务的企业覆盖全球各个地区，包括小米、陌陌、抖音、The Meet Group、VIPKID、好未来等巨头、独角兽及创业企业。'
        },
        {
          link: 'https://www.huaweiyun.com',
          // avatar: 'https://static001-test.geekbang.org/resource/image/17/06/173f90ca1e05c4347996574fdc81bd06.jpg',
          avatar: require('./assets/huaweiyun.jpg'),
          word: '华为云用在线的方式将华为30多年在ICT基础设施领域的技术积累和产品解决方案开放给客户，致力于提供稳定可靠、安全可信、可持续创新的云服务，做智能世界的“黑土地”，推进实现“用得起、用得好、用得放心”的普惠AI。华为云作为底座，为华为全栈全场景AI战略提供强大的算力平台和更易用的开发平台。'
        },
        {
          link: 'https://www.akamai.com/cn',
          // avatar: 'https://static001-test.geekbang.org/resource/image/17/06/173f90ca1e05c4347996574fdc81bd06.jpg',
          avatar: require('./assets/akamai.png'),
          word: '全球领先的智能云平台，被Gartner，Forrester 连续评为Web 应用防火墙(WAF) 领导者，CDN 技术的缔造者。 Akamai（中国）专注于为“出海”公司提供 CDN 加速及Web安全防护服务。我们的服务覆盖全球，部署在26.5+万台服务器和1700 多个ISP中，使用独有的智能边缘安全平台来确保您的网站、Web 应用程序、API被快速以及安全的访问。Akamai 的智能云平台平均每天与130TB的数据，10亿台终端设备、1亿多个IP 地址进行交互，通过大数据提供情报和洞察信息，保障您在线业务的性能与安全。全球500强中50%，Top50中国出海品牌超过60% 的公司正在使用我们的服务。'
        },
        {
          link: 'https://gitee.com',
          // avatar: 'https://static001-test.geekbang.org/resource/image/4b/c4/4b8a1c2694b14fd8eba1e00ea44035c4.jpg',
          avatar: require('./assets/mayun.jpg'),
          word: 'Gitee（gitee.com）是开源中国推出基于的 Git 的代码托管·协作开发平台，提供本土化的代码托管服务，拥有开发者近 500 万，托管项目超过 1000 万，汇聚几乎所有本土原创开源项目。并于 2016 年推出 Gitee 企业版，提供企业级精细代码管理服务，有序规划和管理软件研发全生命周期，至今已有超过 15 万家企业客户，成为开发领域领先的 SaaS 服务提供商。'
        },
        // {
        //   link: 'https://mvp.aliyun.com/',
        //   // avatar: 'https://static001-test.geekbang.org/resource/image/cd/19/cd285d24192ed72a835513e0d168c019.jpg',
        //   avatar: require('./assets/aliyun.png'),
        //   word: '阿里云（www.aliyun.com）创立于2009年，是全球领先的云计算及人工智能科技公司，为200多个国家和地区的企业、开发者和政府机构提供服务。阿里云最有价值专家，简称 MVP（Most Valuable Professional），是全球各行业数字化转型的技术实践领袖；是一群拥有丰富知识、实战经验和行业理解的技术专家；是专注于帮助他人充分了解和使用阿里云的技术精英。活跃在阿里云开发者社区等各大技术社群中，为广大开发者使用到更好的云智能服务做出了极大的贡献。'
        // },
        {
          link: 'https://www.tigergraph.com.cn',
          // avatar: 'https://static001.geekbang.org/resource/image/02/a6/026c84d98b898c6098aa89bf0ae56da6.png',
          avatar: 'https://www.tigergraph.com.cn//wp-content/uploads/2017/09/logo-tigergraph-dark-1.png',
          word: 'TigerGraph特有的原生并行图（NPG）技术使其成为世界上最快的图分析平台。TigerGraph能够实时处理极度复杂的海量数据，帮助客户深度挖掘数据所蕴含的商业价值。TigerGraph支持包括人工智能、实时推荐、反欺诈等需要感知数据瞬息万变的全部业务场景。'
        },
        {
          link: 'https://www.webeye.com/',
          // avatar: 'https://static001-test.geekbang.org/resource/image/3c/89/3c1fc1788131d20011cf06bf6f131b89.jpg',
          avatar: 'https://static001.geekbang.org/resource/image/5c/f9/5c40a5d64ee6d4a6550cb4b4a6bf4af9.png',
          word: 'WebEye网眼（www.webeye.com）成立于2015年6月，致力于用最好的技术连接世界，帮助所有中国企业实现全球增长。WebEye以创新驱动，整合全球资源，以全球应对全球，秉持"Live Data Powers Everything We Do"的技术理念，不设边界勇于创新，在专业技术和服务领域持续探索，打造具有社会责任感的高新技术企业，成为具有行业标杆地位和全球化竞争力的互联网企业。'
        },
        {
          link: 'https://www.jiguang.cn/',
          avatar: 'https://static001.geekbang.org/resource/image/1c/95/1c35e28b999b260b02aeace95e870d95.png',
          word: '超 165 万款 APP 运营、增长、变现首选！消息推送、一键登录、广告变现、智能运营......覆盖金融、电商、教育、社交、游戏等诸多领域。'
        }],
        '2019-2020年度共创伙伴': [{
          link: 'https://docs.agora.io/cn',
          // avatar: 'https://static001-test.geekbang.org/resource/image/e3/9b/e3f635dd1c615f733469a45b5c84159b.jpg',
          avatar: require('./assets/shengwang.png'),
          word: '声网Agora是实时音视频云行业的开创者，是全球最大的专业服务商，每年为全球超过20万开发者提供年千亿分钟实时音视频服务。开发者只需简单调用API，30分钟即可在应用内构建多种实时互动场景，实现视频社交、互动直播、语音开黑、互动课堂、AR远程协作、视频客服等。'
        }, {
          link: 'https://www.tigergraph.com.cn/',
          // avatar: 'https://static001.geekbang.org/resource/image/02/a6/026c84d98b898c6098aa89bf0ae56da6.png',
          avatar: 'https://www.tigergraph.com.cn//wp-content/uploads/2017/09/logo-tigergraph-dark-1.png',
          word: 'TigerGraph特有的原生并行图（NPG）技术使其成为世界上最快的图分析平台。TigerGraph能够实时处理极度复杂的海量数据，帮助客户深度挖掘数据所蕴含的商业价值。TigerGraph支持包括人工智能、实时推荐、反欺诈等需要感知数据瞬息万变的全部业务场景。'
        }, {
          link: 'http://aws.amazon.com',
          avatar: 'https://static001.geekbang.org/resource/image/30/93/3024ebd6775841acb9ae4d979470ac93.png',
          word: '13年以来，Amazon Web Services（AWS）一直是世界上服务丰富、应用广泛的云服务平台。通过位于美国、澳大利亚、巴西、加拿大、中国、法国、德国、印度、爱尔兰、日本、韩国、新加坡、瑞典和英国的21个地理区域、66个可用区（AZ），AWS向客户提供超过165项功能全面的服务，涵盖计算、存储、数据库、联网、分析、机器人、机器学习与人工智能、物联网、移动、安全、混合云、虚拟现实与增强现实、媒体，以及应用服务、部署与管理等方面。全球数百万客户，包括发展迅速的初创公司、大型企业和领先的政府机构信赖AWS，通过AWS的服务强化其基础设施，提高敏捷性，降低成本。'
        }, {
          link: 'http://www.knownsec.com/',
          avatar: require('./assets/zhidaochuangyu.png'),
          word: '知道创宇是一家积极开拓国内云防御和云安全领域，致力于大数据驱动的下一代网络安全高新技术企业。知道创宇也是多家权威机构独角兽榜单中上榜网络安全企业，被媒体称赞为“中国硬独角兽”和“中国酷公司”。'
        }, {
          link: 'http://www.jfrogchina.com/',
          avatar: 'https://static001.geekbang.org/resource/image/9c/f5/9ce9c681301a743bc2ae28f52621d8f5.png',
          word: '杰蛙科技（Jfrog)，是一家端到端一站式DevOps解决方案服务商。2008年成立于美国硅谷。在过去十年里，世界500强中有93%的企业选择杰蛙旗下的Artifactory作为DevOps核心系统。在全球范围内，杰蛙已经拥有4000多个付费客户，其中包括谷歌、思科、Netflix、亚马逊、苹果、ING、微软、富国银行、腾讯、华为、小米、京东、滴滴出行、爱奇艺等。连续两年被德勤评选为50家增长最快的技术公司之一。'
        }, {
          link: 'http://www.inspur.com/',
          avatar: require('./assets/langchao.png'),
          word: '浪潮是云计算、大数据服务商，业务涵盖云数据中心、云服务大数据、智慧城市、智慧企业四大产业群，为全球100多个国家和地区提供IT产品和服务，全方位满足政府与企业信息化需求。2018年，主营业务服务器销量全球前三、互联网行业连续5年第一。'
        }, {
          link: 'https://yun.pingan.com/',
          avatar: 'https://static001-test.geekbang.org/resource/image/92/6d/92b49041e4037eb6a7f3b9ae5f522e6d.jpg',
          word: '平安云诞生于平安集团，是GitHub在大中华区的首个云管理服务提供商(MSP)，提供GitHub企业版的运营与服务。根据企业代码托管需求，支持本地私有部署、云镜像部署、即买即用SaaS服务。通过统一的代码管理工具可以更加便捷高效的集中管控企业代码，整体降低企业运维人员的成本，并助力企业内部形成Inner source文化。'
        }, {
          link: 'https://github.com/TarsCloud',
          avatar: require('./assets/tars.png'),
          word: 'TARS是Linux基金会开源项目。它是高性能开源微服务开发框架，支持C++、Java、Nodejs、PHP、Golang等多种开发语言，并配套服务治理平台。开发者可以敏捷构建稳定可靠的微服务，运维可以享受高效的运营平台，企业可以得到开箱即用的生产级产品。TARS经腾讯十年海量业务磨炼，目前上百家企业、上万名开发者在使用，涵盖即时通讯、直播、视频、游戏、金融、交通、IoT等多个行业。'
        }, {
          link: 'https://www.yunpian.com',
          avatar: require('./assets/yunpian.png'),
          word: '云片成立于2013年，是全球智能云通讯服务商，集成一站式的短信、国际短信、超级短信、语音、5G智慧短信、身份认证和营销管理能力，满足企业在全球范围内的移动通讯及营销需求，助力企业与用户间更简单的沟通。目前全球已有累计18万家企业客户和开发者通过云片API实现了场景化沟通。'
        }]
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../../style/bulma/app.sass"

.partner
  padding-top: 75px
  background-color: #f5f5f5
  +mobile
    padding: 40px 0

</style>
